/**
 * wire_size is the legacy JSON blob ({length, width, diameter, …} each with its
 * own unit key). Render just the populated dimensions — the whole object in a
 * table cell would be unreadable.
 */
export function formatWireSize(raw: string | null): string {
  if (!raw) return "—";
  let o: Record<string, unknown>;
  try {
    o = JSON.parse(raw) as Record<string, unknown>;
  } catch {
    return raw;
  }
  const parts = ["length", "width", "height", "innerWidth", "diameter", "wireDiameter"].flatMap(
    (k) => {
      const v = o[k];
      if (v == null || String(v).trim() === "") return [];
      const unit = o[`${k}Unit`];
      return [`${v}${unit ? String(unit) : ""}`];
    },
  );
  return parts.length ? parts.join(" × ") : "—";
}
